<template>
  <div>
    <template v-if="activeFilterSubject === 'Tất cả' && activeFilterType !== 3">
      <template v-if="!loading && tempListTutorStudyResult.length > 0">
        <div
          v-for="(item, index) in tempListTutorStudyResult"
          :key="index + 'tableTutor'"
          class="d-flex flex-column align-center mt-6"
          style="margin-bottom: 37px;">
          <div style="display: block; overflow: auto; width: 100%">
            <table
              id="style-2"
              class="tutor-study-result-table"
              v-if="$route.query.schoolLevel === SCHOOL_LEVEL.PRIMARY"
            >
              <thead>
              <tr :class="getTableColorByIndex(index)">
                <th style="min-width: 130px; max-width: 130px">Chương trình</th>
                <th style="min-width: 130px; max-width: 130px">Ngày diễn ra</th>
                <th style="min-width: 200px; max-width: 200px">Buổi học</th>
                <th style="min-width: 110px; max-width: 110px">Lớp</th>
                <th class="text-center" style="min-width: 100px; max-width: 100px">Điểm danh</th>
                <th style="min-width: 140px; max-width: 140px">Bài tập/Điểm</th>
                <th style="min-width: 80px; max-width: 80px">Video</th>
                <th style="min-width:280px">Nhận xét</th>
                <th class="text-center" style="min-width: 100px">Thao tác</th>
              </tr>
              </thead>
              <tbody v-if="!loading && tempListTutorStudyResult.length > 0">
              <tr
                :key="'tutor' + index"
              >
                <td>{{mapProgramIdAndProgram[item.curriculum_id] ? mapProgramIdAndProgram[item.curriculum_id].title : ''}}</td>
                <td>{{ item.lesson_start_time ? formatDate(item.lesson_start_time) : '--' }}</td>
                <td>
                  <div>{{ item.lesson_name }}</div>
                  <span v-if="item.isTest && item.isTest !== 1" class="test-tag">{{ EXAM_TEST[`${item.isTest}`]}}</span>
                </td>
                <td>{{ item.class_code ? item.class_code : "--" }}</td>
                <td class="text-center">
            <span v-if="item.attendance === 1">
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.33366 7.08496C0.33366 3.22949 3.45085 0.0849609 7.33366 0.0849609C11.1891 0.0849609 14.3337 3.22949 14.3337 7.08496C14.3337 10.9678 11.1891 14.085 7.33366 14.085C3.45085 14.085 0.33366 10.9678 0.33366 7.08496ZM10.4782 5.88184C10.779 5.58105 10.779 5.11621 10.4782 4.81543C10.1774 4.51465 9.71257 4.51465 9.41179 4.81543L6.45866 7.76855L5.22819 6.56543C4.92741 6.26465 4.46257 6.26465 4.16179 6.56543C3.861 6.86621 3.861 7.33105 4.16179 7.63184L5.91179 9.38184C6.21257 9.68262 6.67741 9.68262 6.97819 9.38184L10.4782 5.88184Z"
                  fill="#4CAF50"
                />
              </svg>
            </span>
                  <span v-else>
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.33366 7.75C0.33366 3.89453 3.45085 0.75 7.33366 0.75C11.1891 0.75 14.3337 3.89453 14.3337 7.75C14.3337 11.6328 11.1891 14.75 7.33366 14.75C3.45085 14.75 0.33366 11.6328 0.33366 7.75ZM5.11882 6.46484L6.40397 7.75L5.11882 9.03516C4.84538 9.30859 4.84538 9.71875 5.11882 9.96484C5.36491 10.2383 5.77507 10.2383 6.02116 9.96484L7.30632 8.67969L8.61882 9.96484C8.86491 10.2383 9.27507 10.2383 9.52116 9.96484C9.7946 9.71875 9.7946 9.30859 9.52116 9.03516L8.236 7.75L9.52116 6.46484C9.7946 6.21875 9.7946 5.80859 9.52116 5.53516C9.27507 5.28906 8.86491 5.28906 8.61882 5.53516L7.30632 6.84766L6.02116 5.53516C5.77507 5.28906 5.36491 5.28906 5.11882 5.53516C4.84538 5.80859 4.84538 6.21875 5.11882 6.46484Z"
                  fill="#F44336"
                />
              </svg>
            </span>
                </td>
                <td>
                  <div class="d-flex justify-space-between">
                    <div v-if="item.subject_id === 5 && item.isTest && item.isTest !== 1">
                      <p v-for="(item,index) in item.skill" :key="'score-test' + index" class="text-left"> <span class="pr-2">{{item.name}}: {{item.score !== '' ? item.score : '--/--'}}</span></p>
                    </div>
                    <div v-else>
                      <div v-for="(item,index) in item.overall.slice(0,2)" :key="'score' + index" class="text-left">
                  <span class="pr-2" style="color: #0088FF; font-weight: bold" v-if="item.linkResult">
                    <v-tooltip top>
                      <template v-slot:activator="{on, attrs}">
                        <span @click="handleRedirect(item.link)" v-on="on" v-bind="attrs" class="hover-to-underline" style="cursor: pointer">{{'BT' + (index + 1)}}</span>
                      </template>
                      <div>Xem đề bài</div>
                    </v-tooltip>
                    :
                    <v-tooltip top>
                      <template v-slot:activator="{on, attrs}">
                        <span @click="handleRedirect(item.linkResult)" v-on="on" v-bind="attrs" class="hover-to-underline" style="cursor: pointer">{{item.score}}</span>
                      </template>
                      <div>Xem kết quả</div>
                    </v-tooltip>
                  </span>
                        <v-tooltip v-else top>
                          <template v-slot:activator="{on, attrs}">
                      <span @click="handleRedirect(item.link)" v-on="on" v-bind="attrs" style="color: #0088FF; font-weight: bold;cursor: pointer" class="hover-to-underline">
                        {{'BT' + (index + 1)}}: Chưa làm
                      </span>
                          </template>
                          <div>Xem đề bài</div>
                        </v-tooltip>
                      </div>
                      <div v-if="item.overall.length > 2" class="d-flex justify-center">
                        <img style="cursor: pointer" src="../assets/more-icon.svg" alt="" @click="handleShowHomework(item.overall, item.lesson_name)">
                        <!--                  <v-icon color="blue">mdi-dots-horizontal</v-icon>-->
                      </div>
                    </div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon v-if="item.subject_id === 5 && item.isTest && item.isTest === 2 && checkScore(item) " @click="showScoreDetail(item)">mdi-information-outline</v-icon>
                </span>
                      </template>
                      <span>Click xem chi tiết điểm học viên</span>
                    </v-tooltip>
                  </div>
                </td>
                <td>
                  <ExpandTextVue v-if="item.link && item.link.length" :textNote="item.link"></ExpandTextVue>
                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on }">
                <span v-on="on" class="link-disable">
                  Link
                </span>
                    </template>
                    <span>Chưa có link video</span>
                  </v-tooltip>
                </td>
                <td>
                  <div v-if="item.teacherCode && item.teacherName" style="color: #0088FF; font-weight: bold">Giáo viên: {{item.teacherCode}} - {{item.teacherName}}</div>
                  <note-teacher :textNote="item.comment"/>
                </td>
                <td class="text-center">
                  <div class="d-flex justify-center" v-if="checkAuthorization('tutor-homeroom-teacher_read')">
                    <div>
                      <v-tooltip bottom v-if="item.comment && item.comment.length" >
                        <template v-slot:activator="{ on }">
                          <span v-on="on" color="#E91E63" size='medi'  @click="EditAction(item)" style="cursor: pointer;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path d="M4.75583 14.4105L12.5 6.66631L8.82167 2.98798L1.0775 10.7321C0.970887 10.8389 0.895153 10.9725 0.858334 11.1188L0 15.488L4.36833 14.6296C4.515 14.593 4.64917 14.5171 4.75583 14.4105ZM15 4.16631C15.3125 3.85377 15.488 3.42992 15.488 2.98798C15.488 2.54604 15.3125 2.12219 15 1.80964L13.6783 0.487978C13.3658 0.175526 12.9419 0 12.5 0C12.0581 0 11.6342 0.175526 11.3217 0.487978L10 1.80964L13.6783 5.48798L15 4.16631Z" fill="#E91E63"/>
                            </svg>
                          </span>
                          <!-- <v-icon >mdi-pencil</v-icon> -->
                        </template>
                        <span>Chỉnh sửa nhận xét</span>
                      </v-tooltip>
                    </div>
                    <div v-if="(isTutorHomeroomTeacher && $route.query.schoolLevel === SCHOOL_LEVEL.PRIMARY) || (isTutorHomeroomTeacherSecondary && $route.query.schoolLevel === SCHOOL_LEVEL.SECONDARY)">
                      <!-- <v-icon color="#E91E63" class="mr-2">mdi-pencil</v-icon> -->
                      <span v-if="checkPublishStatus(item)" class="mx-2">
                        <svg
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.33366 7.08496C0.33366 3.22949 3.45085 0.0849609 7.33366 0.0849609C11.1891 0.0849609 14.3337 3.22949 14.3337 7.08496C14.3337 10.9678 11.1891 14.085 7.33366 14.085C3.45085 14.085 0.33366 10.9678 0.33366 7.08496ZM10.4782 5.88184C10.779 5.58105 10.779 5.11621 10.4782 4.81543C10.1774 4.51465 9.71257 4.51465 9.41179 4.81543L6.45866 7.76855L5.22819 6.56543C4.92741 6.26465 4.46257 6.26465 4.16179 6.56543C3.861 6.86621 3.861 7.33105 4.16179 7.63184L5.91179 9.38184C6.21257 9.68262 6.67741 9.68262 6.97819 9.38184L10.4782 5.88184Z"
                            fill="#4CAF50"
                          />
                        </svg>
                      </span>
                      <span>
                        <v-tooltip bottom v-if="!(item.class_code && item.class_code.includes('TA') && item.isTest === 2) && !item.publishStatus && item.comment && item.comment.length" >
                          <template v-slot:activator="{ on }">
                            <span v-on="on" color="#E91E63"  @click="publishShareAction(item)" style="cursor: pointer;" class="mx-2">
                              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                <path d="M14.7976 5.77734L10.7067 10.2773C10.5788 10.4258 10.419 10.5 10.2273 10.5C10.142 10.5 10.0533 10.4805 9.96094 10.4414C9.68395 10.3086 9.54545 10.0781 9.54545 9.75V7.5H7.84091C5.54688 7.5 3.99148 8.01172 3.17472 9.03516C2.32955 10.1055 2.06676 11.9531 2.38636 14.5781C2.40767 14.7578 2.33665 14.8906 2.1733 14.9766C2.11648 14.9922 2.07386 15 2.04545 15C1.93182 15 1.83949 14.9492 1.76847 14.8477C1.69744 14.7383 1.62287 14.6172 1.54474 14.4844C1.46662 14.3516 1.32635 14.084 1.12393 13.6816C0.92152 13.2793 0.745739 12.8906 0.596591 12.5156C0.447443 12.1406 0.310725 11.6953 0.186435 11.1797C0.062145 10.6641 0 10.1875 0 9.75C0 9.36719 0.012429 9.01172 0.0372869 8.68359C0.0621449 8.35547 0.111861 8.00391 0.186435 7.62891C0.261009 7.25391 0.36044 6.91016 0.48473 6.59766C0.60902 6.28516 0.775923 5.9668 0.98544 5.64258C1.19496 5.31836 1.43821 5.0293 1.7152 4.77539C1.99219 4.52148 2.32777 4.28125 2.72195 4.05469C3.11612 3.82812 3.55824 3.63867 4.0483 3.48633C4.53835 3.33398 5.10476 3.21484 5.74751 3.12891C6.39027 3.04297 7.08807 3 7.84091 3H9.54545V0.75C9.54545 0.421875 9.68395 0.191406 9.96094 0.0585938C10.0533 0.0195313 10.142 0 10.2273 0C10.4119 0 10.5717 0.0742188 10.7067 0.222656L14.7976 4.72266C14.9325 4.87109 15 5.04688 15 5.25C15 5.45312 14.9325 5.62891 14.7976 5.77734Z" fill="#E91E63"/>
                              </svg>
                            </span>
                          </template>
                          <span>Chia sẻ nhận xét</span>
                        </v-tooltip>
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
              <tbody v-if="!loading && !tempListTutorStudyResult.length">
              <tr><td colspan="9" class="text-center"> Không có dữ liệu</td></tr>
              </tbody>
              <tbody v-if="loading">
              <tr  v-for="(item,index) in 4" :key="'loading-tr'+index">
                <td v-for="(item,index) in 9" :key="'loading-td'+index"><span class="skeleton-box" style="width: 100%"></span></td>
              </tr>
              </tbody>
            </table>
            <HomeWorkTable
              :is-loading="loading"
              :homeworks="{data: [item]}"
              :lms-core-user-id="studentBlendedTutorDetail.lms_core_user_id"
              v-else-if="$route.query.schoolLevel === SCHOOL_LEVEL.SECONDARY"
              disable-footer
              :show-expand="false"
              is-blended
              :header-class="getTableColorByIndex(index)"
              height=""
              @publish-share-action="publishShareAction(item)"
              :is-self-study="!item.curriculum_id"
              :is-preview="true"
              @redirect-care-homework="handleRedirectCareHomework"></HomeWorkTable>
          </div>
          <div class="view-detail-btn mt-4" :class="getTableColorByIndex(index)" @click="handleViewProgramDetail(item)">
            Xem chi tiết
            <v-icon color="white" class="ml-3">mdi-arrow-right</v-icon>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="d-flex align-center justify-center" style="height: 150px">
          Không có dữ liệu
        </div>
      </template>
    </template>
    <template v-else>
      <div v-if="$route.query.schoolLevel === SCHOOL_LEVEL.PRIMARY">
        <div class="d-flex justify-end pb-3">
          <div class="text-right mb-1 mt-2">
            <template>
              {{ showContactsIndex }}
            </template>
            <v-btn
              small
              class="pagination-btn-left ml-2 mr-2"
              :disabled="filterFormTable.page === 1"
              @click="changePage('left', filterFormTable.page)"
            >
              <v-icon>mdi-menu-left</v-icon>
            </v-btn>
            <v-btn
              small
              class="ml-2 mr-2 pagination-btn-right"
              :disabled="filterFormTable.page === totalItem"
              @click="changePage('right', filterFormTable.page)"
            >
              <v-icon>mdi-menu-right</v-icon>
            </v-btn>
          </div>
          <div style="width: 35px">
            <v-text-field
              v-model="filterFormTable.page"
              :max="totalItem"
              class="pt-0"
              min="1"
              step="1"
              type="number"
              hide-details
              @input="applyPendingPage($event)"
            >
            </v-text-field>
          </div>
        </div>
        <div style="width: 100%; overflow: auto; display: block">
          <v-simple-table id="style-2" class="tutor-study-result-table" fixed-header height="500">
            <template v-slot:default>
              <thead>
              <tr>
                <th style="min-width: 130px; max-width: 130px">Ngày diễn ra</th>
                <th style="min-width: 160px; max-width: 160px">Buổi học</th>
                <th style="min-width: 110px; max-width: 110px">Lớp</th>
                <th class="text-center" style="min-width: 100px; max-width: 100px">Điểm danh</th>
                <th style="min-width: 140px">Bài tập/Điểm</th>
                <th style="min-width: 120px">Thời lượng học thực tế</th>
                <th>Video</th>
                <th style="min-width:200px">Nhận xét</th>
                <th class="text-center" style="min-width: 100px">Thao tác</th>
              </tr>
              </thead>
              <tbody v-if="!loading && listTutorStudyResultHavePagination.length">
              <tr
                v-for="(item, index) in listTutorStudyResultHavePagination"
                :key="'tutor' + index"
              >
                <td>{{ item.lesson_start_time ? formatDate(item.lesson_start_time) : '--' }}</td>
                <td>
                  <div>{{ item.lesson_name }}</div>
                  <span v-if="item.isTest && item.isTest !== 1" class="test-tag">{{ EXAM_TEST[`${item.isTest}`]}}</span>
                </td>
                <td>{{ item.class_code ? item.class_code : "--" }}</td>
                <td class="text-center">
            <span v-if="item.attendance === 1">
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.33366 7.08496C0.33366 3.22949 3.45085 0.0849609 7.33366 0.0849609C11.1891 0.0849609 14.3337 3.22949 14.3337 7.08496C14.3337 10.9678 11.1891 14.085 7.33366 14.085C3.45085 14.085 0.33366 10.9678 0.33366 7.08496ZM10.4782 5.88184C10.779 5.58105 10.779 5.11621 10.4782 4.81543C10.1774 4.51465 9.71257 4.51465 9.41179 4.81543L6.45866 7.76855L5.22819 6.56543C4.92741 6.26465 4.46257 6.26465 4.16179 6.56543C3.861 6.86621 3.861 7.33105 4.16179 7.63184L5.91179 9.38184C6.21257 9.68262 6.67741 9.68262 6.97819 9.38184L10.4782 5.88184Z"
                  fill="#4CAF50"
                />
              </svg>
            </span>
                  <span v-else>
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.33366 7.75C0.33366 3.89453 3.45085 0.75 7.33366 0.75C11.1891 0.75 14.3337 3.89453 14.3337 7.75C14.3337 11.6328 11.1891 14.75 7.33366 14.75C3.45085 14.75 0.33366 11.6328 0.33366 7.75ZM5.11882 6.46484L6.40397 7.75L5.11882 9.03516C4.84538 9.30859 4.84538 9.71875 5.11882 9.96484C5.36491 10.2383 5.77507 10.2383 6.02116 9.96484L7.30632 8.67969L8.61882 9.96484C8.86491 10.2383 9.27507 10.2383 9.52116 9.96484C9.7946 9.71875 9.7946 9.30859 9.52116 9.03516L8.236 7.75L9.52116 6.46484C9.7946 6.21875 9.7946 5.80859 9.52116 5.53516C9.27507 5.28906 8.86491 5.28906 8.61882 5.53516L7.30632 6.84766L6.02116 5.53516C5.77507 5.28906 5.36491 5.28906 5.11882 5.53516C4.84538 5.80859 4.84538 6.21875 5.11882 6.46484Z"
                  fill="#F44336"
                />
              </svg>
            </span>
                </td>
                <td>
                  <div class="d-flex justify-space-between">
                    <div v-if="item.subject_id === 5 && item.isTest && item.isTest !== 1">
                      <p v-for="(item,index) in item.skill" :key="'score-test' + index" class="text-left"> <span class="pr-2">{{item.name}}: {{item.score !== '' ? item.score : '--/--'}}</span></p>
                    </div>
                    <div v-else>
                      <div v-for="(item,index) in item.overall.slice(0,2)" :key="'score' + index" class="text-left">
                  <span class="pr-2" style="color: #0088FF; font-weight: bold" v-if="item.linkResult">
                    <v-tooltip top>
                      <template v-slot:activator="{on, attrs}">
                        <span @click="handleRedirect(item.link)" v-on="on" v-bind="attrs" class="hover-to-underline" style="cursor: pointer">{{'BT' + (index + 1)}}</span>
                      </template>
                      <div>Xem đề bài</div>
                    </v-tooltip>
                    :
                    <v-tooltip top>
                      <template v-slot:activator="{on, attrs}">
                        <span @click="handleRedirect(item.linkResult)" v-on="on" v-bind="attrs" class="hover-to-underline" style="cursor: pointer">{{item.score}}</span>
                      </template>
                      <div>Xem kết quả</div>
                    </v-tooltip>
                  </span>
                        <v-tooltip v-else top>
                          <template v-slot:activator="{on, attrs}">
                      <span @click="handleRedirect(item.link)" v-on="on" v-bind="attrs" style="color: #0088FF; font-weight: bold;cursor: pointer" class="hover-to-underline">
                        {{'BT' + (index + 1)}}: Chưa làm
                      </span>
                          </template>
                          <div>Xem đề bài</div>
                        </v-tooltip>
                      </div>
                      <div v-if="item.overall.length > 2" class="d-flex justify-center">
                        <img style="cursor: pointer" src="../assets/more-icon.svg" alt="" @click="handleShowHomework(item.overall, item.lesson_name)">
                        <!--                  <v-icon color="blue">mdi-dots-horizontal</v-icon>-->
                      </div>
                    </div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon v-if="item.subject_id === 5 && item.isTest && item.isTest === 2 && checkScore(item) " @click="showScoreDetail(item)">mdi-information-outline</v-icon>
                </span>
                      </template>
                      <span>Click xem chi tiết điểm học viên</span>
                    </v-tooltip>
                  </div>
                </td>
                <td class="text-center">{{item.time}} phút</td>
                <td>
                  <ExpandTextVue v-if="item.link && item.link.length" :textNote="item.link"></ExpandTextVue>
                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on }">
                <span v-on="on" class="link-disable">
                  Link
                </span>
                    </template>
                    <span>Chưa có link video</span>
                  </v-tooltip>
                </td>
                <td>
                  <div v-if="item.teacherCode && item.teacherName" style="color: #0088FF; font-weight: bold;">Giáo viên: {{item.teacherCode}} - {{item.teacherName}}</div>
                  <note-teacher :textNote="item.comment"/>
                </td>
                <td class="text-center">
                  <div class="d-flex justify-center" v-if="checkAuthorization('tutor-homeroom-teacher_read')">
                    <div>
                      <v-tooltip bottom v-if="item.comment && item.comment.length" >
                        <template v-slot:activator="{ on }">
                          <span v-on="on" color="#E91E63" size='medi'  @click="EditAction(item)" style="cursor: pointer;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path d="M4.75583 14.4105L12.5 6.66631L8.82167 2.98798L1.0775 10.7321C0.970887 10.8389 0.895153 10.9725 0.858334 11.1188L0 15.488L4.36833 14.6296C4.515 14.593 4.64917 14.5171 4.75583 14.4105ZM15 4.16631C15.3125 3.85377 15.488 3.42992 15.488 2.98798C15.488 2.54604 15.3125 2.12219 15 1.80964L13.6783 0.487978C13.3658 0.175526 12.9419 0 12.5 0C12.0581 0 11.6342 0.175526 11.3217 0.487978L10 1.80964L13.6783 5.48798L15 4.16631Z" fill="#E91E63"/>
                            </svg>
                          </span>
                          <!-- <v-icon v-on="on" size='small' color="#E91E63"  @click="EditAction(item)" style="cursor: pointer;">mdi-pencil</v-icon> -->
                        </template>
                        <span>Chỉnh sửa nhận xét</span>
                      </v-tooltip>
                    </div>
                    <div v-if="(isTutorHomeroomTeacher && $route.query.schoolLevel === SCHOOL_LEVEL.PRIMARY) || (isTutorHomeroomTeacherSecondary && $route.query.schoolLevel === SCHOOL_LEVEL.SECONDARY)">
                    <!-- <v-icon color="#E91E63" class="mr-2">mdi-pencil</v-icon> -->
                      <span v-if="checkPublishStatus(item)" class="mx-2">
                        <svg
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.33366 7.08496C0.33366 3.22949 3.45085 0.0849609 7.33366 0.0849609C11.1891 0.0849609 14.3337 3.22949 14.3337 7.08496C14.3337 10.9678 11.1891 14.085 7.33366 14.085C3.45085 14.085 0.33366 10.9678 0.33366 7.08496ZM10.4782 5.88184C10.779 5.58105 10.779 5.11621 10.4782 4.81543C10.1774 4.51465 9.71257 4.51465 9.41179 4.81543L6.45866 7.76855L5.22819 6.56543C4.92741 6.26465 4.46257 6.26465 4.16179 6.56543C3.861 6.86621 3.861 7.33105 4.16179 7.63184L5.91179 9.38184C6.21257 9.68262 6.67741 9.68262 6.97819 9.38184L10.4782 5.88184Z"
                            fill="#4CAF50"
                          />
                        </svg>
                      </span>
                      <span>
                        <v-tooltip bottom v-if="!(item.class_code && item.class_code.includes('TA') && item.isTest === 2) && !item.publishStatus && item.comment && item.comment.length" >
                          <template v-slot:activator="{ on }">
                            <span v-on="on" color="#E91E63"  @click="publishShareAction(item)" style="cursor: pointer;" class="mx-2">
                              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                <path d="M14.7976 5.77734L10.7067 10.2773C10.5788 10.4258 10.419 10.5 10.2273 10.5C10.142 10.5 10.0533 10.4805 9.96094 10.4414C9.68395 10.3086 9.54545 10.0781 9.54545 9.75V7.5H7.84091C5.54688 7.5 3.99148 8.01172 3.17472 9.03516C2.32955 10.1055 2.06676 11.9531 2.38636 14.5781C2.40767 14.7578 2.33665 14.8906 2.1733 14.9766C2.11648 14.9922 2.07386 15 2.04545 15C1.93182 15 1.83949 14.9492 1.76847 14.8477C1.69744 14.7383 1.62287 14.6172 1.54474 14.4844C1.46662 14.3516 1.32635 14.084 1.12393 13.6816C0.92152 13.2793 0.745739 12.8906 0.596591 12.5156C0.447443 12.1406 0.310725 11.6953 0.186435 11.1797C0.062145 10.6641 0 10.1875 0 9.75C0 9.36719 0.012429 9.01172 0.0372869 8.68359C0.0621449 8.35547 0.111861 8.00391 0.186435 7.62891C0.261009 7.25391 0.36044 6.91016 0.48473 6.59766C0.60902 6.28516 0.775923 5.9668 0.98544 5.64258C1.19496 5.31836 1.43821 5.0293 1.7152 4.77539C1.99219 4.52148 2.32777 4.28125 2.72195 4.05469C3.11612 3.82812 3.55824 3.63867 4.0483 3.48633C4.53835 3.33398 5.10476 3.21484 5.74751 3.12891C6.39027 3.04297 7.08807 3 7.84091 3H9.54545V0.75C9.54545 0.421875 9.68395 0.191406 9.96094 0.0585938C10.0533 0.0195313 10.142 0 10.2273 0C10.4119 0 10.5717 0.0742188 10.7067 0.222656L14.7976 4.72266C14.9325 4.87109 15 5.04688 15 5.25C15 5.45312 14.9325 5.62891 14.7976 5.77734Z" fill="#E91E63"/>
                              </svg>
                            </span>
                          </template>
                          <span>Chia sẻ nhận xét</span>
                        </v-tooltip>
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
              <tbody v-if="!loading && !listTutorStudyResultHavePagination.length">
              <tr><td colspan="9" class="text-center"> Không có dữ liệu</td></tr>
              </tbody>
              <tbody v-if="loading">
              <tr  v-for="(item,index) in 4" :key="'loading-tr'+index">
                <td v-for="(item,index) in 9" :key="'loading-td'+index"><span class="skeleton-box" style="width: 100%"></span></td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div v-else-if="$route.query.schoolLevel === SCHOOL_LEVEL.SECONDARY" class="mt-4">
        <HomeWorkTable
          :homeworks="{data: [...listTutorStudyResultFilter]}"
          :is-loading="loading"
          height="650"
          :isSelfStudy="activeCurriculumId === 0"
          :is-blended="true"
          :lms-core-user-id="studentBlendedTutorDetail.lms_core_user_id"
          @redirect-care-homework="handleRedirectCareHomework"
        />
      </div>
    </template>
    <v-dialog v-if="showDetail" v-model="showDetail" max-width="770">
      <score-detail :curriculumID="curriculumId" :lessonID="lessonId"/>
    </v-dialog>
    <HomeworkDialog :isShow="isShowHomeworkDialog" :homeworks="homeworks" @close="isShowHomeworkDialog = false"/>
    <v-dialog v-model="publishShare" persistent max-width="600">
      <v-card>
        <v-card-title class="text-h4" style="font-weight:700">
          Chia sẻ nhận xét
          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>

        <v-card-text>
          Bạn có chắc chắn muốn chia sẻ nhận xét buổi học với phụ huynh học sinh ?
          <br/>
          Nhận xét sẽ được hiển thị trên web và app gia sư khi bạn xác nhận
        </v-card-text>

        <v-card-actions style="text-align: end;">
          <v-spacer></v-spacer>

          <v-btn
            class="cancel-button"
            @click="hideModal"
          >
            Hủy
          </v-btn>

          <v-btn
            class="update-button"
            @click="shareFeedbackStudent()"
          >
            Xác nhận
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        <v-dialog v-model="isEditComment" max-width="800" persistent>
      <v-card class="quick-view">
        <v-card-title class="font-weight-bold px-5">
          Chỉnh sửa nhận xét
          <v-icon aria-label="Close" @click="closeModal()">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-textarea
            v-model="newComment"
            hint="Không được để trống phần nhận xét"
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="pa-5 group-btn-comment" style="text-align: end;">
          <v-btn @click="closeModal()" class="cancel-button">
            Hủy
          </v-btn>
          <v-btn outlined color="pink" @click="saveAndShare()">
            Lưu & chia sẻ với HS
          </v-btn>
          <v-btn class="update-button" @click="saveComment()">
            Lưu
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BlendedCareRepository from '@/services/BlendedCareRepository';
import HomeworkDialog from '@/modules/student_detail_bt/HomeworkDialog.vue';
import HomeWorkTable from '@/components/table/homework/HomeWorkTable.vue';
import moment from 'moment';
import { mapGetters, mapState, mapActions } from 'vuex';
import { EXAM_TEST, SCHOOL_LEVEL } from '@/helpers/constant';
import StudentCareServices from '@/services/StudentCareServices';
import ScoreDetail from './ModalScoreDetail/ScoreDetail.vue';
import NoteTeacher from './ModalScoreDetail/NoteTeacher.vue';
import ExpandTextVue from './ModalScoreDetail/ExpandText.vue';

export default {
  components: {
    ScoreDetail, NoteTeacher, ExpandTextVue, HomeworkDialog, HomeWorkTable,
  },
  name: 'TutorStudyResultTab',
  props: {
    isExistSelfStudy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      SCHOOL_LEVEL,
      isShowHomeworkDialog: false,
      showDetail: false,
      lessonId: null,
      homeworks: {},
      listTutorStudyResult: [],
      EXAM_TEST,
      loading: false,
      curriculumId: null,
      publishShare: false,
      shareId: null,
      filterFormTable: {
        page: 1,
      },
      listTutorStudyResultHavePagination: [],
      totalItem: 0,
      isEditComment: false,
      newComment: '',
      itemReview: null,
    };
  },
  computed: {
    ...mapGetters('user', ['isTutorHomeroomTeacher', 'isTutorHomeroomTeacherSecondary']),
    ...mapState('student_detail_bt', ['filterForm', 'studentBlendedTutorDetail', 'activeFilterSubject', 'activeFilterType', 'activeCurriculumId']),
    ...mapGetters('student_care', ['mapProgramIdAndProgram']),
    listTutorStudyResultFilter() {
      if (this.activeFilterType === 3) return [];
      return this.activeFilterSubject !== 'Tất cả' ? this.listTutorStudyResult.filter((e) => {
        if (this.activeCurriculumId === 0) {
          return e.curriculum_id === 0;
        } return this.mapProgramIdAndProgram[e.curriculum_id]?.title === this.activeFilterSubject;
      }) : _.cloneDeep(this.listTutorStudyResult);
    },
    showContactsIndex() {
      return `${this.filterFormTable.page === 1 ? 1 : this.filterFormTable.page * 10} - ${this.listTutorStudyResultFilter.length - (this.filterFormTable.page * 20) < 1 ? this.listTutorStudyResultFilter.length : this.filterFormTable.page * 20} / ${this.listTutorStudyResultFilter.length}`;
    },
    tempListTutorStudyResult() {
      const result = [];
      this.listTutorStudyResult.forEach((e) => {
        if (!result.some((el) => e.curriculum_id === el.curriculum_id)) {
          result.push(e);
        }
      });
      return result;
    },
  },
  async mounted() {
    await this.getTutorStudyResult();
  },
  watch: {
    activeFilterSubject() {
      this.listTutorStudyResultHavePagination = this.listTutorStudyResultFilter.slice((this.filterFormTable.page === 1 ? 0 : this.filterFormTable.page * 10), (this.listTutorStudyResultFilter.length - (this.filterFormTable.page * 20) < 20 ? this.listTutorStudyResultFilter.length : this.filterFormTable.page * 20));
    },
    'filterFormTable.page': {
      handler(val) {
        this.listTutorStudyResultHavePagination = this.listTutorStudyResultFilter.slice((val === 1 ? 0 : val * 10), (this.listTutorStudyResultFilter.length - (val * 20) < 20 ? this.listTutorStudyResultFilter.length : val * 20));
      },
    },
    'filterForm.dateTime': {
      handler(val) {
        if (val) {
          this.filterFormTable.page = 1;
          this.getTutorStudyResult();
        }
      },
      deep: true,
    },
    showDetail(val) {
      if (val === false) {
        this.curriculumId = null;
      }
    },
  },
  methods: {
    ...mapActions('student_care', ['sendComment']),
    async handleRedirectCareHomework(date, item) {
      const params = {
        lms_core_user_id: this.studentBlendedTutorDetail.lms_core_user_id,
        curriculum_id: this.activeCurriculumId ? this.activeCurriculumId : item.curriculum_id,
      };
      if (this.mapProgramIdAndProgram[this.activeCurriculumId] && this.mapProgramIdAndProgram[this.activeCurriculumId].code === 'CAM') {
        params.lesson_date = this.formatDateCus(date, 'YYYY-MM-DD');
      }
      const response = await StudentCareServices.getCareHomeworkReference(params);
      if (response && response.message === 'Success') {
        window.open(response.data.link, '_blank');
      }
    },
    handleRedirect(link) {
      window.open(link);
    },
    handleViewProgramDetail(item) {
      const program = {
        value: item.curriculum_id,
        name: this.mapProgramIdAndProgram[item.curriculum_id]?.title,
        type: 'tutor',
        program_subject_id: item.subject_id,
      };
      console.log(program);
      Bus.$emit('filter-tutor-program', program);
    },
    getTableColorByIndex(index) {
      const mod = index % 3;
      switch (mod) {
        case 0:
          return 'first-table';
        case 1:
          return 'second-table';
        case 2:
          return 'third-table';
        default:
      }
      return '';
    },
    handleShowHomework(homework, title) {
      this.homeworks = {
        title,
        homeworkDetail: homework,
      };
      this.isShowHomeworkDialog = true;
    },
    showScoreDetail(item) {
      this.curriculumId = item.curriculum_id;
      this.lessonId = item.lesson_id;
      this.showDetail = true;
    },
    async getTutorStudyResult() {
      this.loading = true;
      const loading = this.$loading.show();
      try {
        const params = {
          id: this.studentBlendedTutorDetail.lms_core_user_id,
          startTime: this.filterForm.dateTime[0],
          endTime: this.filterForm.dateTime[1],
        };
        const paramsSelfStudy = {
          lms_core_user_id: this.studentBlendedTutorDetail.lms_core_user_id,
          // lms_core_user_id: 1485752,
          startTime: this.filterForm.dateTime[0],
          endTime: this.filterForm.dateTime[1],
        };
        // const params = {
        //   id: 4917,
        //   startTime: '2023-09-01',
        //   endTime: '2023-09-30',
        // };
        let res = null;
        if (this.$route.query.schoolLevel === SCHOOL_LEVEL.PRIMARY) {
          res = await BlendedCareRepository.getTutorStudyResult(params);
        } else if (this.$route.query.schoolLevel === SCHOOL_LEVEL.SECONDARY) {
          if (this.isExistSelfStudy) {
            const [selfStudyResult, tutorStudyResult] = await Promise.all([
              BlendedCareRepository.getSelfStudyResult(paramsSelfStudy),
              BlendedCareRepository.getTutorStudyResultSecondary(paramsSelfStudy),
            ]);
            res = {
              data: [
                ...selfStudyResult.data.data.map((e) => ({
                  curriculum_id: 0,
                  ...e,
                })),
                ...tutorStudyResult.data.data,
              ],
            };
          } else {
            res = await BlendedCareRepository.getTutorStudyResultSecondary(paramsSelfStudy);
            res = res.data;
          }
        }
        if (res && res.data) {
          const commentIds = [];
          res.data.forEach((element) => {
            if (element.comment_ids) {
              commentIds.push(...element.comment_ids);
            }
          });
          if (commentIds && commentIds.length) {
            const paramsFG = {
              obj: 'comment',
              attrs: ['id', 'publish_status'],
              'filters[$in__id]': commentIds,
            };
            const result = await BlendedCareRepository.fgGetListCare(paramsFG);
            if (result && result.data) {
              this.listTutorStudyResult = res.data.map((item) => {
                const findID = result.data.find((key) => (item.comment_ids && item.comment_ids.length ? item.comment_ids.includes(key.id.toString()) : false));
                if (findID) {
                  return { ...item, publishStatus: findID.publish_status === 1, curriculum_id: item.curriculumId ? item.curriculumId : item.curriculum_id };
                }
                return { ...item, publishStatus: false, curriculum_id: item.curriculumId ? item.curriculumId : item.curriculum_id };
              });
              this.listTutorStudyResultHavePagination = this.listTutorStudyResultFilter.slice(0, 20);
              this.totalItem = this.listTutorStudyResultFilter.length % 20 === 0 ? Math.floor(this.listTutorStudyResultFilter.length / 20) : (Math.floor(this.listTutorStudyResultFilter.length / 20) + 1);
            }
          } else {
            this.listTutorStudyResult = res.data;
            this.listTutorStudyResult = this.listTutorStudyResult.map((e) => ({
              curriculum_id: e.curriculumId,
              ...e,
            }));
            this.listTutorStudyResultHavePagination = this.listTutorStudyResultFilter.slice(0, 20);
            this.totalItem = this.listTutorStudyResultFilter.length % 20 === 0 ? Math.floor(this.listTutorStudyResultFilter.length / 20) : (Math.floor(this.listTutorStudyResultFilter.length / 20) + 1);
          }
          this.listTutorStudyResult.forEach((e) => {
            if (!this.tempListTutorStudyResult.some((el) => el.curriculum_id === e.curriculum_id)) {
              this.tempListTutorStudyResult.unshift(e);
            }
          });
        }
        if (res && res.errors) {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Có lỗi xảy ra vui lòng thử lại !!!',
          });
        }
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
      loading.hide();
    },
    formatDate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY');
      }
      return '-';
    },
    checkPublishStatus(item) {
      if (!item.class_code) return false;
      if (item.class_code.includes('TA') && item.isTest === 2 && item.skill.length && !['', '0/0', 'null/null'].includes(item.skill[0].score.trim())) return true;
      if (item.publishStatus) return true;
      return false;
    },
    publishShareAction(item) {
      this.publishShare = true;
      this.shareId = item;
    },
    hideModal() {
      this.publishShare = false;
      this.shareId = null;
    },
    async shareFeedbackStudent() {
      const loading = this.$loading.show();
      const params = {
        obj: 'comment',
        data: {
          comment_content: this.shareId.comment.join('. '),
          publish_status: 1,
        },
        filters: {
          $in__id: this.shareId.comment_ids,
        },
      };
      const res = await BlendedCareRepository.apiUpdateComment(params);
      if (res && res.message === 'Success') {
        this.shareId.publishStatus = true;
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: res.message ?? 'Có lỗi xảy ra khi thực hiện thao tác!',
        });
      }
      loading.hide();
      this.hideModal();
    },
    checkScore(item) {
      if (item.skill && !item.skill.length) return false;
      const array = item.skill.filter((key) => ![''].includes(key.score.trim()));
      if (array.length === 4) {
        return true;
      }
      return false;
    },
    changePage(key, page) {
      if (key === 'left') {
        this.filterFormTable.page = page - 1;
      } else {
        this.filterFormTable.page = page + 1;
      }
    },
    applyPendingPage(event) {
      if (Number(event) > this.totalItem) {
        this.filterFormTable.page = this.totalItem;
      }
      if (event.trim() === '') {
        this.filterFormTable.page = 1;
      }
    },
    EditAction(item) {
      this.isEditComment = true;
      this.newComment = item.comment && item.comment.length ? item.comment[0] : '';
      this.itemReview = item.comment_ids && item.comment_ids.length ? { id: item.comment_ids[0] } : null;
      this.shareId = item;
    },
    saveAndShare() {
      if (this.newComment === '') {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Không được để trống phần nhận xét!',
        });
        return;
      }
      if (!this.itemReview?.id) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Không tìm thấy bản ghi nhận xét, vui lòng thử lại!',
        });
        return;
      }
      this.saveComment();
      this.shareFeedbackStudent();
    },
    closeModal() {
      this.isEditComment = false;
      this.newComment = '';
      this.itemReview = null;
      this.shareId = null;
    },
    async saveComment() {
      if (this.newComment === '') {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Không được để trống phần nhận xét!',
        });
        return;
      }
      if (!this.itemReview?.id) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Không tìm thấy bản ghi nhận xét, vui lòng thử lại!',
        });
        return;
      }
      const params = {
        id: this.itemReview?.id,
        comment_content: this.newComment,
      };
      const res = await this.sendComment(params);
      if (!res) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Có lỗi xảy ra khi gửi nhận xét cho học sinh!',
        });
        return;
      }
      this.$swal({
        type: 'success',
        title: 'Thành công!',
        text: 'Đã lưu nhận xét!',
      });
    },
  },
};
</script>

<style scoped lang="scss">
.tutor-study-result-table {
  border-spacing: 0;
  width: 100%;
}
.tutor-study-result-table {
  width: 100%;
  max-height: 500px;
  overflow: auto;
  thead {
    position: sticky;
    top: 0;
    z-index: 1;
    tr {
      th {
        height: 42px !important;
        color: black !important;
        text-align: left;
        min-width: 80px;
        padding: 8px 12px;
        background: #fbd9e9 !important;
        font-size: 14px !important;
      }
      &.first-table {
        th {
          background: #FBD9E9 !important;
        }
      }
      &.second-table {
        th {
          background: #CCFFF3 !important;
        }
      }
      &.third-table {
        th {
          background: #FBEFD9 !important;
        }
      }
    }
  }
  tbody {
    tr {
      td {
        padding: 12px 16px !important;
        border-bottom: 1px solid #E8E8E8;
      }
    }
    .test-tag {
      padding: 4px 8px;
      border-radius: 7px;
      background: #ADBEF8;
      color: #030877;
      font-size: 10px;
      font-style: normal;
      font-weight: 700;
      line-height: 16px; /* 200% */
      margin: 0px;
    }
    .skeleton-box {
      display: inline-block;
      height: 1em;
      position: relative;
      overflow: hidden;
      background-color: #dddbdd;

      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background-image: linear-gradient(
          90deg,
          rgba(#fff, 0) 0,
          rgba(#fff, 0.2) 20%,
          rgba(#fff, 0.5) 60%,
          rgba(#fff, 0)
        );
        animation: shimmer 5s infinite;
        content: "";
      }

      @keyframes shimmer {
        100% {
          transform: translateX(100%);
        }
      }
    }
  }
}
.update-button {
  background-color: #fd1f6d !important;
  color: white;
}
.cancel-button {
  background: #bdbdbd !important;
  color: #333;
}
.link-disable {
  color: #bdbdbd;
  cursor: not-allowed;
}
.view-detail-btn {
  cursor: pointer;
  color: white;
  padding: 2px 8px;
  border-radius: 8px;
  display: flex;
  font-size: 12px;
  font-weight: bold;
  align-items: center;
  transition: all .2s ease-in-out;
  &.first-table {
    background: #BF4C91;
  }
  &.second-table {
    background: #42BA88;
  }
  &.third-table {
    background: #BA9842;
  }
  &:hover {
    scale: 1.1;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  }
}
@media screen and (max-width: 1440px) {
 .tutor-study-result-table {
   thead {
    position: sticky;
    top: 0;
    z-index: 1;
    tr th {
      //min-width: 80px;
      background: #fbd9e9;
    }
  }
  tbody {
    tr {
      td {
        padding: 6px;
        border-bottom: 1px solid #9747ff33;
        text-align: left;
      }
    }
    .test-tag {
      padding: 4px 8px;
      border-radius: 7px;
      background: #ADBEF8;
      color: #030877;
      font-size: 10px;
      font-style: normal;
      font-weight: 700;
      line-height: 16px; /* 200% */
      margin: 0px;
    }
    .skeleton-box {
      display: inline-block;
      height: 1em;
      position: relative;
      overflow: hidden;
      background-color: #dddbdd;

      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background-image: linear-gradient(
          90deg,
          rgba(#fff, 0) 0,
          rgba(#fff, 0.2) 20%,
          rgba(#fff, 0.5) 60%,
          rgba(#fff, 0)
        );
        animation: shimmer 5s infinite;
        content: "";
      }

      @keyframes shimmer {
        100% {
          transform: translateX(100%);
        }
      }
    }
  }
 }
}
.update-button {
  background-color: #CE2375 !important;
  color: white !important;
}
.cancel-button {
  background: #D2D2D2 !important;
  color: #333;
}
</style>
<style>
#custom-dialog {
  max-height: 98% !important;
}
.hover-to-underline:hover {
  text-decoration: underline;
}
</style>
